import { useEffect } from 'react';

export const useScrollAnimation = () => {
  useEffect(() => {
    const addInView = (el: Element) => el.classList.add('in-view');

    // Feature detection fallback
    const ioSupported = 'IntersectionObserver' in window;
    
    const observer = ioSupported
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                addInView(entry.target);
              }
            });
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px',
          }
        )
      : null;

    // Observe all current and future elements with animate-on-scroll
    const observeAll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => {
        if (observer) {
          observer.observe(el);
        } else {
          // Fallback: immediately make visible
          addInView(el);
        }
      });
    };

    // Initial observation
    observeAll();

    // Watch for DOM changes to observe newly added elements
    const mutationObserver = new MutationObserver(() => {
      observeAll();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      mutationObserver.disconnect();
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
};